import useMultipleCostInvoiceDrafts from 'tennders-finance/cost-invoice/hooks/useMultipleCostInvoiceDrafts'
import TableLoading from 'tennders-market/common/components/element/TableLoading'
import GHref from 'tennders-market/common/components/element/GHref'
import React, { useEffect } from 'react'
import dynamic from 'next/dynamic'

const EllipsisToolTip = dynamic(() => import('ellipsis-tooltip-react-chan'), { ssr: false })

const MultipleCostInvoiceDrafts = ({ selectDraft }) => {
  const {
    loading,
    drafts,
    fetchDrafts,
    deleteDraft
  } = useMultipleCostInvoiceDrafts({})

  useEffect(() => {
    fetchDrafts()
  }, [fetchDrafts])
  return drafts.length && !loading ? (
    <>
      <div className="d-flex column">
        <div className="hr">
        </div>
        <h4 className="mt-10">Choose a draft</h4>
        {loading && <TableLoading />}
        <div className="tennders-table-responsive tennders-custom-scroll">
          <table className="tennders-table-zebra mb-24">
            <thead>
              <tr>
                <th>Invoice No</th>
                <th>Transactions</th>
                <th>Created By</th>
                <th>Created At</th>
                <th colSpan={2}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {drafts.map(draft => (
                <tr key={draft.id + draft.invoiceNo + draft?.content?.document?.id}>
                  <td>
                    <EllipsisToolTip options={{ className: 'custom-color-tooltip' }}>
                      {draft.invoiceNo}
                    </EllipsisToolTip>
                  </td>
                  <td>{draft.oplog?.lines?.map(line => line.referenceNumber).join(',')}</td>
                  <td>{draft.createdBy?.name}</td>
                  <td>{draft.createdAt}</td>
                  <td>
                    <div className="d-flex row">
                      <GHref onClick={() => selectDraft(draft)}>
                        <img alt="edit" src="/img/icon-edit.svg" />
                      </GHref>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex row">
                      <GHref onClick={() => deleteDraft(draft?.id)}>
                        <img alt="edit" src="/img/icon-trash.svg" />
                      </GHref>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  ) : null
}

export default MultipleCostInvoiceDrafts
